import { ReactNode } from "react";
import { Alert } from "react-bootstrap";
import Translate from "src/components/Translate";

type Props = {
  element: string;
  blocked: boolean;
  verified: boolean;
  privated?: boolean;
  alerts?: boolean | null | undefined;
  children?: ReactNode;
};

function ValidateContent({
  element,
  blocked,
  verified,
  privated,
  alerts,
  children,
}: Props) {
  return (
    <>
      {blocked ? (
        alerts ? (
          <Alert variant={`warning`}>
            <Translate tKey={element + ` `} />
            <Translate tKey={`is blocked`} />
          </Alert>
        ) : null
      ) : !verified ? (
        alerts ? (
          <Alert variant="danger">
            <Translate tKey={element + ` `} />
            <Translate tKey={`is not verified`} />
          </Alert>
        ) : null
      ) : privated ? (
        alerts ? (
          <Alert variant={`warning`}>
            <Translate tKey={element + ` `} />
            <Translate tKey={`is private`} />
          </Alert>
        ) : null
      ) : (
        children
      )}
    </>
  );
}

export default ValidateContent;
